import React from "react";

function Footer() {
    return (
        <footer>
            <div class="footer-content">
                <p>All Rights Reserved. Terra Virtua.</p>
            </div>
        </footer>
    )
}

export default Footer;